import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=691b07c6&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('691b07c6')) {
      api.createRecord('691b07c6', component.options)
    } else {
      api.reload('691b07c6', component.options)
    }
    module.hot.accept("./delivery.vue?vue&type=template&id=691b07c6&", function () {
      api.rerender('691b07c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/info-blocks/delivery.vue"
export default component.exports